import {signOutEverywhere} from "../firebase";

// The web mirror of the connector's tool-less session: the Google
// account is real, Nefes does not know it. Fail closed, say why.
export function NotRegistered({email}: {email: string}) {
  return (
    <main className="card-page">
      <section className="card">
        <h1>Kayıtlı değil</h1>
        <p>
          <b>{email}</b> Google'da tanındı ama Nefes'e kayıtlı değil.
          Yöneticiden bu e-postayı kaydetmesini isteyin, sonra tekrar girin.
        </p>
        <button onClick={() => void signOutEverywhere()}>Başka hesapla gir</button>
      </section>
    </main>
  );
}
